import commonApi from './CommonApi.js';

export default {
	getForDropdown: async (parameter) => {
		return await commonApi().get('/v1/hsVersions/getForDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getLastUsedHSVersion: async (parameter) => {
		return await commonApi().get('/v1/hsVersions/getLastUsedHSVersion', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getLatestHSVersion: async (parameter) => {
		return await commonApi().get('/v1/hsVersions/getLatestHSVersion', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	}
}